























import { User } from 'oidc-client';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { PerformoSettings, ReportQueue, ReportsApi } from 'performo-api';

import ReportPreview from '@/components/reports/ReportPreview.vue';
import { ColumnDisplayOption } from '@/models/ColumnDisplayOption';
import { handleApiError } from '@/ApiHelpers';

@Component({
  components: {
    ReportPreview
  },
  computed: mapGetters({
    currentPropertyId: 'currentPropertyId',
    currentUser: 'currentUser',
    api: 'reportsApi',
    settings: 'settings'
  })
})
export default class ReportList extends Vue {
  @Prop({ required: false }) columnDisplay!: ColumnDisplayOption[];

  private currentPropertyId!: string;
  private currentUser!: User;
  private api!: ReportsApi;
  private settings!: PerformoSettings;

  private reports!: ReportQueue[];

  get columnDisplayComputed(): ColumnDisplayOption[] {
    // this computed value uses the incoming prop if defined, but if not uses a sensible default.
    return this.columnDisplay
      ? this.columnDisplay
      : [
          {
            displayName: 'Report Name',
            columnName: 'reportName',
            width: '200px',
            dontSort: true
          },
          {
            displayName: this.settings.multiPropLabelSingular || 'Property',
            columnName: 'propertyId',
            width: '100px',
            dontSort: true
          },
          {
            displayName: 'Type',
            columnName: 'outputType',
            width: '100px',
            dontSort: true
          },
          {
            displayName: 'Run Date',
            columnName: 'runDateTime',
            width: '125px',
            dateFormatKind: 3,
            dontSort: true
          },
          {
            displayName: 'View',
            columnName: 'previewAction',
            width: '100px',
            dontSort: true
          }
        ];
  }

  private modalShow = false;

  data() {
    return {
      reports: undefined
    };
  }

  private async mounted() {
    // mounted
    try {
      this.reports = await this.api.getMyReportHistory();
    } catch (error) {
      handleApiError(error);
    }
  }
}
